import youtubeApi from '@/api/youtube.js'

// Used to get youtube video title by video ID
export const getYoutubeVideoData = async videoId => {
  const videoInfo = await axios.get(
    `https://noembed.com/embed?url=https://www.youtube.com/watch?v=${videoId}`
  )

  return videoInfo.data
}

export const addVideoTitles = views => {
  const titlePromises = []

  views.forEach(view => {
    if (!view.video_data.title) {
      const getTitle = getYoutubeVideoData(view.video_data.video_id)
      .then(data => {
        view.video_data.title = data.title
      })

      titlePromises.push(getTitle)
    }
  })

  return Promise.all(titlePromises)
}

export const addVideoTitle = async (view) => {
  const videoData = await getYoutubeVideoData(view.video_data.video_id)

  return {
    ...view,
    video_data: {
      ...view.video_data,
      title: videoData.title
    }
  }
}

// Caching video titles in NetNanny Server
export const updateYoutubeViewsData = views => {
  const updatedViews = views.map(view => {
    return {
      id: view.id,
      video_data: {
        title: view.video_data.title
      }
    }
  })

  if (updatedViews.length) {
    return youtubeApi.updateViews(updatedViews)
  }

  return views
}